import { render, staticRenderFns } from "./floorImg-two.vue?vue&type=template&id=23795e14&scoped=true"
import script from "./floorImg-two.vue?vue&type=script&lang=js"
export * from "./floorImg-two.vue?vue&type=script&lang=js"
import style0 from "./floorImg-two.vue?vue&type=style&index=0&id=23795e14&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23795e14",
  null
  
)

export default component.exports